/**
 * StateProfile — UML State Machine diagrams.
 * See plans/software-design/domain.md § 5.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type StateNodeType = 'state_state' | 'state_initial' | 'state_final' | 'state_choice' | 'state_fork_join' | 'state_history';
export type StateEdgeType = 'state_transition';

export const StateProfile: DomainDataProfile<StateNodeType, StateEdgeType> = {
  domainId: 'state',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['state_state', 'state_initial', 'state_final', 'state_choice', 'state_fork_join', 'state_history'],
  edgeTypes: ['state_transition'],
  vocabulary: {
    recordSingular: 'State',
    recordPlural: 'States',
    repositoryLabel: 'State Machine',
    hierarchyLabel: 'Transitions',
    importAction: 'Import States',
    keyColumnHint: 'State',
    commitLabel: 'Push States',
    pullLabel: 'Refresh States',
    diagramLabel: 'state machine',
  },
  fieldAliases: {
    name: ['stateName', 'state'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'state_state',
  propsToAttrsMapping: {
    name: 'name',
    entry: 'entry',
    exit: 'exit',
    do: 'doAction',
  },
  relationshipPackId: 'software-design-relationships',
};
